<template>
  <div class="login-header">
    <div class="title">{{ passwordLogin ? '账号密码登录' : '登录' }}</div>
    <div v-if="!passwordLogin"
         class="content"
    >
      <ym-img class="icon"
              :src="require('@/assets/img/default/login_icon_gift.png')"
      />
      <span>三重新人好礼免费领</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LoginHeader',
    props: {
      passwordLogin: Boolean,
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .login-header {
    width: 100%;
    height: 224px;
    padding: 80px 50px 24px;
    background-image: url("~@/assets/img/default/login_bg.png");
    background-size: 100% 100%;
    box-sizing: border-box;
    .title {
      color: @color-black-dark;
      font-size: 56px;
      font-weight: @font-weight-bold;
      line-height: 1;
      text-align: left;
    }
    .content {
      display: flex;
      align-items: center;
      margin-top: 28px;
      .icon {
        width: 40px;
        height: 36px;
        margin-right: 10px;
      }
      span {
        color: #fa405e;
        font-size: 30px;
        font-weight: @font-weight-bold;
      }
    }
  }
</style>
